/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { RootStore } from 'src/core/stores/RootStore';
import { VersionedAppId } from 'src/luis/types/VersionedAppId';

/**
 * This decorator simply gets the app version store
 * corresponding to the ids given and mark all predictions as dirty.
 *
 * @param rootStore The root store of the website.
 * @param ids An object containing the app and version id.
 */
export const addInvalidatePredictions = (rootStore: RootStore, ids: VersionedAppId) => async (
    transaction: Promise<void>
): Promise<void> => {
    await transaction;

    const appStore = rootStore.luisAppStoreHouse.findById(ids.appId);

    if (!appStore) {
        return;
    }

    const appVersionStore = appStore.appVersionStoreHouse.findById(ids.versionId);

    if (!appVersionStore) {
        return;
    }

    appVersionStore.predictionStoreHouse.invalidatePredictions();
};
